import Button from "devextreme-react/button";
import { exportDataGrid } from 'devextreme/excel_exporter';
import dxDataGrid from "devextreme/ui/data_grid";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { useTitle } from "../../contexts/title";

export default function ExportToExcelButton(props: { dataGrid: dxDataGrid }) {

	const { title } = useTitle();
	const fileName = title.replace(/[^a-z0-9_-]/gi, '_') + '.xlsx';

	return (
		<Button
			icon="xlsxfile"
			text="Export to Excel"
			onClick={() => {
				const workbook = new Workbook();
				const worksheet = workbook.addWorksheet("Sheet1");

				exportDataGrid({
					component: props.dataGrid,
					worksheet,
					autoFilterEnabled: true,
				}).then(() => {
					workbook.xlsx.writeBuffer().then((buffer) => {
						saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
					});
				});
			}} >
		</Button>
	)
}
